import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class WizardNavButtonsStylingModel extends CoreStylingModel {
/**
 * Styling by type ButtonStylingModel
 */
buttonStyling?: ButtonStylingModel;
/**
 * It is the constructor for the WizardStepStylingModel. It takes the values to create the WizardStepStylingModel object.
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}

function WizardNavButtonsStylingModel_tsickle_Closure_declarations() {
/**
 * Styling by type ButtonStylingModel
 * @type {?}
 */
WizardNavButtonsStylingModel.prototype.buttonStyling;
}

